import { STAFF_PATHS } from '../utils/staffPaths';
import { jwtDecode } from 'jwt-decode';

export const getToken = () => localStorage.getItem('token');
export const getAdminToken = () => localStorage.getItem('Admintoken');

export const setToken = (token) => localStorage.setItem('token', token);
export const setAdminToken = (token) => localStorage.setItem('Admintoken', token);

export const removeToken = () => localStorage.removeItem('token');
export const removeAdminToken = () => localStorage.removeItem('Admintoken');

export const isTokenExpired = (token) => {
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        return !Number.isFinite(decoded.exp) || decoded.exp <= Date.now() / 1000;
    } catch {
        return true;
    }
};

// Where to land after signing in, for a signed-out visitor who followed a deep link such
// as /upgrade. sessionStorage so it dies with the tab, and only same-site paths are
// honoured so it can never become an open redirect.
const POST_LOGIN_KEY = 'postLoginPath';

export const rememberPostLoginPath = (path) => {
    try { sessionStorage.setItem(POST_LOGIN_KEY, path); } catch { /* storage blocked */ }
};

export const consumePostLoginPath = () => {
    let path = null;
    try {
        path = sessionStorage.getItem(POST_LOGIN_KEY);
        sessionStorage.removeItem(POST_LOGIN_KEY);
    } catch { /* storage blocked */ }
    return path && path.startsWith('/') && !path.startsWith('//') ? path : '/dashboard';
};

export const isAuthenticated = () => {
    const token = getToken();
    return token && !isTokenExpired(token);
};
export const isStaffToken = (token) => {
    if (!token || isTokenExpired(token)) return false;
    try {
        const claims = jwtDecode(token);
        return claims.token_type === 'internal_staff' && claims.aud === 'pipsqueak-internal' &&
            claims.iss === 'pipsqueak-staff' && ['admin', 'marketing'].includes(claims.role);
    } catch {
        return false;
    }
};

export const isAdminAuthenticated = () => isStaffToken(getAdminToken());

// Navigation hint only. InternalStaffRoute and every backend API re-check the DB role.
export const getStaffLandingPath = () => {
    try { return jwtDecode(getAdminToken()).role === 'marketing' ? STAFF_PATHS.marketing : STAFF_PATHS.dashboard; }
    catch { return STAFF_PATHS.login; }
};

// Get current user ID from token
export const getUserId = () => {
    const token = getToken();
    if (!token) return null;
    
    try {
        const decoded = jwtDecode(token);
        return decoded.userId || decoded.user || decoded.id || null;
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};
